import { forwardRef } from 'react'
import SimpleBar from 'simplebar-react'
import styled from 'styled-components'

const SimpleBarStyled = styled(SimpleBar)`
  width: ${(props) => props.width};
`

const Scrollbar = forwardRef(({ children, maxHeight, ...props }, ref) => {
  return (
    <SimpleBarStyled ref={ref} {...props} style={{ maxHeight }}>
      {children}
    </SimpleBarStyled>
  )
})

Scrollbar.displayName = 'Scrollbar'

export default Scrollbar
